jQuery(document).ready(function ($) {
    if (typeof ajaxpagination === 'undefined' || !ajaxpagination.ajaxurl) {
        console.error("AJAX Pagination Error: ajaxpagination is not defined.");
        return;
    }

    // Event delegation for dynamically loaded pagination links
    $(document).on('click', '.pagination a', function (event) {
        event.preventDefault();

        var pageUrl = $(this).attr('href');
        var page = pageUrl.split('paged=')[1] || 1;

        $.ajax({
            url: ajaxpagination.ajaxurl,
            type: 'POST',
            data: {
                action: 'ajax_pagination',
                page: page
            },
            beforeSend: function () {
                $('#post-container').fadeTo(300, 0.5);
            },
            success: function (response) {
                var newContent = $('<div>').html(response); 

                // Replace post container content
                $('#post-container').html(newContent.find('#post-container').html()).fadeTo(300, 1);

                // Replace pagination
                $('#pagination-container').html(newContent.find('.pagination').html());

                // Update browser URL
                history.pushState(null, null, pageUrl);
            },
            error: function (xhr, status, error) {
                console.error("AJAX Error:", error);
            }
        });
    });

    // Handle browser back/forward navigation
    window.onpopstate = function () {
        location.reload();
    };
});
